module.exports = __webpack_public_path__ + "static/media/Homepage1.ee3d9581.jpg";